import { Flex, Text } from '@bitrise/bitkit';
import React, { FunctionComponent } from 'react';
import GuideCodeLine from './GuideCodeLine';
import './GuideCode.css';

interface Props {
  bash?: boolean;
  children: string;
  copy?: boolean | boolean[];
}

const GuideCode: FunctionComponent<Props> = (props) => {
  const { bash, children, copy, ...rest } = props;
  const lines = children.split('\n');

  return (
    <Flex
      {...rest}
      borderRadius="x2"
      className="GuideCode"
      direction="horizontal"
      overflow="hidden"
      textColor="gray-7"
    >
      <Flex
        backgroundColor="gray-2"
        className="GuideCode__gutter"
        paddingHorizontal="x2"
        paddingVertical="x4"
      >
        {lines.map((_, i) => (
          <Text
            config="8"
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            paddingHorizontal="x2"
            paddingVertical="x1"
            weight={Array.isArray(copy) && copy[i] ? 'bold' : undefined}
          >
            {i + 1}
          </Text>
        ))}
      </Flex>

      <Flex
        backgroundColor="gray-1"
        grow
        initial="none"
        overflow="auto"
        paddingHorizontal="x2"
        paddingVertical="x4"
      >
        {lines.map((line, i) => (
          <GuideCodeLine
            bash={bash}
            copy={Array.isArray(copy) ? copy[i] : copy}
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            weight={Array.isArray(copy) && copy[i] ? 'bold' : undefined}
          >
            {line}
          </GuideCodeLine>
        ))}
      </Flex>
    </Flex>
  );
};

export default GuideCode;
